import versionData from './version'

export const properties = {
  amplitudeApiKey: AMPLITUDE_API_KEY,
  analyticsSessionTime: 30 * 60 * 1000,
  assetsToken: '_bt',
  baseAiUri: AI_BASE_URI,
  baseApiUri: API_BASE_URI,
  codeVersion: versionData.version,
  debugSubdomain: DEBUG_SUBDOMAIN,
  defaultSubdomain: DEFAULT_SUBDOMAIN || 'app',
  drinkingOptions: [['cup', 'Cup'], ['beaker', 'Beaker'], ['bottle', 'Bottle']],
  env: APP_ENV,
  helpDeskNumber: '+44 (0) 1923 545 200',
  identityExpireTime: 29, // days, represented in days. API set token for 30days
  identityKey: IDENTITY_KEY,
  identityKeyLegacy: `AUTH_V9_${APP_ENV}`,
  idlePromptTimeout: 60000,
  infoBannerExpirationTime: 15, // days
  knowledgeBase: 'https://helpcentre.blossomeducational.com/en/',
  nurseryDomainPrefix: NURSERY_DOMAIN_PREFIX || 'https://',
  nurseryDomainSuffixes: [
    '.bmapp.co.uk',
    '.blossom.localhost',
    '.blossomeducational.com',
    '.dev.blsm.uk',
    '.staging.blsm.uk',
    '.demo.blsm.uk',
    '.hotfix.blsm.uk',
    '.dev.blsmlab.co.uk',
    '.staging.blsmlab.co.uk',
    '.demo.blsmlab.co.uk',
    '.hotfix.blsmlab.co.uk',
  ],
  observationStates: [['emerging', 'Emerging'], ['developing', 'Developing'], ['secure', 'Secure']],
  pagination: {
    marginPagesDisplayed: 1,
    pageRangeDisplayed: 1,
  },
  paymentsImportTemplateFileName: 'Payment import template.csv',
  pinIdentityKey: PIN_IDENTITY_KEY,
  ravenDNS: RAVEN_DNS,
  tmpIdentityKey: TMP_IDENTITY_KEY,
  referralLink: 'https://blossomeducational.com/refer-blossom/?utm_source=nursery-app&utm_medium=referrral&utm_campaign=amazon-voucher', // eslint-disable-line
  release: RELEASE,
  sentry: {
    ignoreErrors: [
      'Invalid attempt to spread non-iterable instance',
      /Invalid attempt to spread non-iterable instance.*/gm,
      'ResizeObserver loop limit exceeded',
      'The network connection was lost.',
      'Non-Error exception captured',
      'SERVICE_CALL_ERROR:  [status 401]',
      'SERVICE_CALL_ERROR:  [status 403]',
      'SERVICE_CALL_ERROR:  [status undefined]',
      /chrome-extension:\/\//gm,
      /safari-extension:\/\//gm,
      /UnhandledRejection: Non-Error promise rejection captured with value: Object Not Found Matching Id:*/,
      /UnhandledRejection: Non-Error promise rejection captured with value: Object Not Found Matching Id:*/gm,
    ],
  },
  showMaintenanceBanner: false,
  supportEmail: 'support@blossomeducational.com',
  tinyMceApiKey: TINY_MCE,
  toilettingOptions: [
    ['nappies', 'Nappies'], ['training', 'Training'], ['toilet-trained', 'Toilet trained'],
  ],
  upload: {
    chunk: 3,
    limits: {
      activity: 100,
      child: 50,
      membership: 50,
      nursery: 100,
      observation: 100,
    },
    statusesDelay: 5000,
  },
  userTitles: ['Mr', 'Mrs', 'Ms', 'Miss', 'Master', 'Dr'],
}
